<template>
  <div ref="root" :class="{ 'lazy-mount-pending': !visible }">
    <slot v-if="visible" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref } from "vue";

// Mounts its content (and so its API calls) only once it comes near the
// viewport: the dashboard charts below the fold don't load with the page.
export default defineComponent({
  name: "LazyMount",
  setup() {
    const root = ref<HTMLElement | null>(null);
    const visible = ref(false);
    let observer: IntersectionObserver | undefined;

    onMounted(() => {
      if (!("IntersectionObserver" in window) || !root.value) {
        visible.value = true;
        return;
      }
      observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            visible.value = true;
            observer?.disconnect();
          }
        },
        { rootMargin: "200px 0px" }
      );
      observer.observe(root.value);
    });
    onBeforeUnmount(() => observer?.disconnect());

    return { root, visible };
  },
});
</script>

<style scoped>
.lazy-mount-pending {
  min-height: 240px;
}
</style>
